export var CONTEST_ENTRY_IMAGE_FORMATS = [
    'jpeg',
    'jpg',
    'png',
    'gif',
];
export var CONTEST_ENTRY_VIDEO_FORMATS = [
    'mov',
    'mpg',
    'mpeg',
    'avi',
    'flv',
];
export var CONTEST_ENTRY_AWARD_STATUSES = [
    "won" /* WON */,
    "won_closed" /* WON_CLOSED */,
    "won_runner_up" /* WON_RUNNER_UP */,
    "won_bronze" /* WON_BRONZE */,
    "won_silver" /* WON_SILVER */,
    "won_gold" /* WON_GOLD */,
    "chosen" /* CHOSEN */,
];
/** Set of contest entry statuses allowed to be shown in CVP */
export var VISIBLE_ENTRIES_DEFAULT_FILTER = [
    "withdrawn" /* WITHDRAWN */,
    "withdrawn_eliminated" /* WITHDRAWN_ELIMINATED */,
    "eliminated" /* ELIMINATED */,
    "active" /* ACTIVE */,
    "bought" /* BOUGHT */
].concat(CONTEST_ENTRY_AWARD_STATUSES);
